import React from "react";
import { View, Text } from "@react-pdf/renderer";

export default function DgiSection({ S, data }) {
  const transactionCode = data.transaction_code || data.order_id || data.machine_code_order_id || "";
  const orderCode = data.order_id || data.machine_code_order_id || "";

  return (
    <View style={[S.box, { marginTop: 10 }]}>
      <Text style={S.label}>Validacion DGI</Text>

      <View style={{ flexDirection: "row", marginTop: 6 }}>
        <View style={{ flex: 1, paddingRight: 12 }}>
          <Text style={S.muted}>
            Consulte por la clave de acceso en:
          </Text>

          <Text
            style={{
              fontSize: 8,
              marginTop: 4,
              wordBreak: "break-all",
            }}
          >
            https://dgi-fep.mef.gob.pa/Consultas/FacturasPorCUFE
          </Text>

          <View style={{ marginTop: 6 }}>
            <Text style={S.bold}>CUFE:</Text>
            <Text>{data.cufe}</Text>
          </View>

          {(transactionCode || orderCode) && (
            <View style={{ marginTop: 6 }}>
              {transactionCode && (
                <Text>
                  <Text style={S.bold}>Número de factura:</Text> #{transactionCode}
                </Text>
              )}
            </View>
          )}
        </View>
      </View>
    </View>
  );
}
